import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

// Logica de proteção de rota (Guard)
const authGuard = (to: any, from: any, next: any) => {
  const token = localStorage.getItem("token");
  if (!token && to.path !== "/login") {
    next("/login");
  } else {
    next();
  }
};

const routes: Array<RouteConfig> = [
  
  {
    path: "/login",
    component: () => import(/* webpackChunkName: "public" */ "@/layouts/Public.vue"),
    children: [
      { 
        path: "", 
        name: "Login", 
        component: () => import("@/views/Login.vue") 
      }
    ],
  },
  {
    path: "/",
    component: () => import(/* webpackChunkName: "private" */ "@/layouts/Private.vue"),
    beforeEnter: authGuard,
    children: [
      { 
        path: "home", 
        name: "Home", 
        component: () => import("@/views/Home.vue") 
      },
      { 
        path: "historico-vendas", 
        name: "SaleHistoryList", 
        component: () => import("@/views/sale-history/SaleHistoryList.vue") 
      },
      { 
        path: "maquinas", 
        name: "MachineList", 
        component: () => import("@/views/machine/MachineList.vue") 
      },
      { 
      path: "maquinas/:id", 
      name: "MachineDetails", 
      component: () => import("@/views/machine/MachineDetails.vue") 
    },
      { 
  path: "preco-dinamico", 
  name: "PrecoDinamicoList", 
  component: () => import("@/views/preco-dinamico/PrecoDinamicoList.vue") 
},
{ 
  path: "preco-dinamico/novo", 
  name: "PrecoDinamicoNovo", 
  component: () => import("@/views/preco-dinamico/PrecoDinamicoForm.vue") 
},
{ 
  path: "preco-dinamico/:id", 
  name: "PrecoDinamicoEdit", 
  component: () => import("@/views/preco-dinamico/PrecoDinamicoForm.vue") 
},

{ 
  path: "combos", 
  name: "ComboList", 
  component: () => import("@/views/combo/ComboList.vue") 
},
{ 
  path: "combos/novo", 
  name: "ComboNovo", 
  component: () => import("@/views/combo/ComboForm.vue") 
},
{ 
  path: "combos/:id", 
  name: "ComboEdit", 
  component: () => import("@/views/combo/ComboEdit.vue") 
},

{ 
  path: "cashback", 
  name: "CashbackList", 
  component: () => import("@/views/cashback/CashbackList.vue") 
},
      { 
        path: "cupons",  
        name: "CouponList", 
        component: () => import("@/views/coupon/CouponList.vue") 
      },   
{ 
    path: "cupons/:id", 
    name: "CouponDetails", 
    component: () => import("@/views/coupon/CouponDetails.vue") 
},

      { 
        path: "upboxes", 
        name: "UpboxList", 
        component: () => import("@/views/upbox/UpboxList.vue") 
      },
{ 
      path: "upboxes/:id", 
      name: "UpboxDetails", 
      component: () => import("@/views/upbox/UpboxDetails.vue") 
    },
      { 
        path: "clientes", 
        name: "ClienteList", 
        component: () => import("@/views/cliente/ClienteList.vue") 
      },

      { 
        path: "clientes/cadastrar", 
        name: "ClienteCreate", 
        component: () => import("@/views/cliente/ClienteForm.vue") 
      },
      { 
        path: "clientes/:id", 
        name: "ClienteEdit", 
        component: () => import("@/views/cliente/ClienteEdit.vue") 
      },

      { 
  path: "totens", 
  name: "PaymentTotemList", 
  component: () => import("@/views/payment-totem/PaymentTotemList.vue") 
},
{ 
  path: "totens/:id", 
  name: "PaymentTotemDetails", 
  component: () => import("@/views/payment-totem/PaymentTotemDetails.vue") 
},

      { 
        path: "parametros", 
        name: "ParametrosList", 
        component: () => import("@/views/parametros/ParametrosList.vue") 
      },

      /* Módulo de Notas Fiscais (NFSe) */
      //{
        //path: "notas-fiscais",
        // component: { render: (h: any) => h("router-view") },
        //children: [
         // { 
          //  path: "configuracoes", 
          //  name: "NfseConfig", 
          //  component: () => import("@/views/nfse/NfseConfig.vue") 
        //  },
      //  ],
    //  },
    ],
  },
  // Rota para 404 ou redirecionamento caso digitem algo errado
  {
    path: "*",
    redirect: "/home",
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,
});

export default router;